import React from "react";
import { searchDestinations } from "@/lib/fitconnect.ts";
import { Frown, Search } from "lucide-react";
import { DestinationSearchResult } from "@/components/DestinationSearchResult.tsx";
import { LoadingState, RoutingDestination } from "@/types/fitconnect";
import { toast } from "sonner";

const SearchDestination = () => {
  const [loadingState, setLoadingState] =
    React.useState<LoadingState>("initial");
  const [ars, setArs] = React.useState("057540052052");
  const [leika, setLeika] = React.useState("99107009017000");
  const [data, setData] = React.useState<RoutingDestination[]>([]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoadingState("pending");
      setData([]);

      const response = await searchDestinations(ars, leika);

      setData(response.destinations);
      setLoadingState(response.error ? "error" : "success");

      if (response.error) {
        toast.error("Suche fehlgeschlagen", {
          description: response.error,
        });
      }
    } catch (error) {
      const msg = error instanceof Error ? error.message : "unbekannter Fehler";
      setLoadingState("error");
      toast.error("Suche fehlgeschlagen", {
        description: msg,
      });
    }
  };

  return (
    <main className="container flex flex-col gap-5">
      <div className="mb-1">
        <h2 className="text-2xl font-bold mb-1">Zustellpunkte suchen</h2>
        <p className="text-base-content/70">
          FIT-Connect Zustellpunkte via Routingdienst suchen.
        </p>
      </div>

      <div className="card bg-base-100 shadow-sm">
        <form
          onSubmit={handleSubmit}
          className="card-body grid grid-cols-3 items-end gap-5"
        >
          <fieldset className="fieldset">
            <legend className="fieldset-legend">ARS</legend>
            <input
              value={ars}
              onChange={(e) => setArs(e.target.value)}
              required
              className="input w-full"
              placeholder="ARS eingeben"
            />
          </fieldset>
          <fieldset className="fieldset">
            <legend className="fieldset-legend">LeiKa-Schlüssel</legend>
            <input
              value={leika}
              onChange={(e) => setLeika(e.target.value)}
              required
              className="input w-full"
              placeholder="LeiKa Schlüssel eingeben"
            />
          </fieldset>

          <fieldset className="fieldset">
            <button type="submit" className="btn btn-primary w-full">
              <Search />
              Suchen
            </button>
          </fieldset>
        </form>
      </div>

      <div className="w-full flex flex-col gap-5">
        {loadingState === "pending" && (
          <div className="flex py-12 text-2xl font-semibold text-slate-600 justify-center items-center">
            <span className="loading loading-spinner loading-xl"></span>
          </div>
        )}
        {loadingState === "success" && data.length === 0 && (
          <div className="flex py-12 text-2xl font-semibold text-slate-600 justify-center items-center">
            <Frown className="mr-3" />
            Keine Ergebnisse
          </div>
        )}
        {loadingState === "success" && data.length > 0 && (
          <div className="text-sm text-gray-500">
            {data.length} Zustellpunkt(e)
          </div>
        )}
        {loadingState === "success" &&
          data.length > 0 &&
          data.map((result) => (
            <DestinationSearchResult
              key={result.destinationId}
              result={result}
            />
          ))}
      </div>
    </main>
  );
};

export default SearchDestination;
